/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { ReactElement, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonBase } from "@mui/material";

import {ReactComponent as HomeIcon} from '../../assets/icons/home.svg';
import {ReactComponent as SongIcon} from '../../assets/icons/song.svg';
import {ReactComponent as CircleIcon} from '../../assets/icons/add-circle.svg';
import {ReactComponent as BookmarkIcon} from '../../assets/icons/bookmark.svg';
import {ReactComponent as ProfileIcon} from '../../assets/icons/profile-icon.svg';
import {ReactComponent as ArrowLeft} from '../../assets/icons/arrow-back.svg';
import logo from "../../assets/images/logo-horizontal.png";
import logoOnly from "../../assets/images/logo-only.png";
import { useStore } from "../../store";
import config from "../../config";
import { storeType } from '../../types';

export default function Footer() {
  const navigate = useNavigate();
  const {store,updateStoreFunc} = useStore(); 
  const handleNavigationClick = (link: string) =>{
    if(link === store.currentPage) return;
    updateStoreFunc("currentPage",link);
    navigate(`${link}`);
  }

  const pageSelectedColor = config.color.pageSelectedColor;
  const pageNameColor = config.color.pageNameColor;
  const footerBgColor = config.color.footerBgColor;
  
  return (
    store.screenType === 'mobile' ?
    <MobileView
      handleNavigationClick={handleNavigationClick}
      pageNameColor={pageNameColor}
      pageSelectedColor={pageSelectedColor}
      footerBgColor={footerBgColor}
    />
    : 
    <TabletView
      handleNavigationClick={handleNavigationClick}
      pageNameColor={pageNameColor}
      pageSelectedColor={pageSelectedColor}
      footerBgColor={footerBgColor}
    />
  )
}

type DataType = {
  handleNavigationClick: (link: string) => void;
  pageSelectedColor: string;
  pageNameColor: string;
  footerBgColor: string;

}
const MobileView = ({ handleNavigationClick, pageNameColor, pageSelectedColor, footerBgColor} : DataType) => {
  const {store} = useStore();

  const text = store.text;

  return (
    <div style={{maxWidth: config.mobileScreenWidth,height: "60px",marginLeft: "auto",marginRight:"auto",display: "flex",flexDirection: "row",justifyContent: "space-evenly",alignItems: "center",padding: "",position: "fixed",bottom: 0,right: 0,left: 0,zIndex: 1000,backgroundColor: footerBgColor}} >
        <ButtonBase   style={{width: '55px',height: "50px",borderRadius: "25px"}}   onClick={()=>handleNavigationClick("/home")}>
            <div style={{display: "flex",flexDirection: "column",justifyContent: 'center',alignItems: "center"}}>
              <HomeIcon fill={(store.currentPage == "/home") ? pageSelectedColor : "none"}/>
              <h5 style={{margin: "5px 0 0 0",fontSize: "10px",color: (store.currentPage == "/home") ? pageSelectedColor : pageNameColor}}>{text.Home}</h5>
            </div>
        </ButtonBase>

        <ButtonBase  style={{width: '55px',height: "50px",borderRadius: "25px"}} onClick={()=>handleNavigationClick("/songRequests")}>
            <div style={{display: "flex",flexDirection: "column",justifyContent: 'center',alignItems: "center"}}>
              <SongIcon width={25} height={25} fill={(store.currentPage == "/songRequests") ? pageSelectedColor : "none"}/>
              <h5 style={{margin: "5px 0 0 0",fontSize: "10px",color: (store.currentPage == "/songRequests") ? pageSelectedColor : pageNameColor}}>{text["Song Request"]}</h5>
            </div>
        </ButtonBase>

        <ButtonBase   style={{width: '55px',height: "50px",borderRadius: "25px"}}  onClick={()=>handleNavigationClick("/dataEntry")}>
          <div style={{display: "flex",flexDirection: "column",justifyContent: 'center',alignItems: "center"}}>
            <CircleIcon fill={(store.currentPage == "/dataEntry") ? pageSelectedColor : "none"}/>
            <h5 style={{margin: "5px 0 0 0",fontSize: "10px",color: (store.currentPage == "/dataEntry") ? pageSelectedColor : pageNameColor}}>{text['Data Entry']}</h5>
          </div>
        </ButtonBase>

        <ButtonBase   style={{width: '55px',height: "50px",borderRadius: "25px"}}   onClick={()=>handleNavigationClick("/library")}>
          <div style={{display: "flex",flexDirection: "column",justifyContent: 'center',alignItems: "center"}}>
            <BookmarkIcon fill={(store.currentPage == "/library") ? pageSelectedColor : "none"}/>
            <h5 style={{margin: "5px 0 0 0",fontSize: "10px",color: (store.currentPage == "/library") ? pageSelectedColor : pageNameColor}}>{text.Library}</h5>
          </div>
        </ButtonBase>

        <ButtonBase   style={{width: '55px',height: "50px",borderRadius: "25px"}} onClick={()=>handleNavigationClick("/profile")}>
          <div style={{display: "flex",flexDirection: "column",justifyContent: 'center',alignItems: "center"}}>
            <ProfileIcon width={25} height={25} fill={(store.currentPage == "/profile") ? pageSelectedColor : "none"}/>
            <h5 style={{margin: "5px 0 0 0",fontSize: "10px",color: (store.currentPage == "/profile") ? pageSelectedColor : pageNameColor}}>{text.Profile}</h5>
          </div>
        </ButtonBase>

      </div>
  )
}



const TabletView = ({ handleNavigationClick, pageNameColor, pageSelectedColor, footerBgColor} : DataType) => {
  const {store, updateStoreFunc} = useStore();

  const text = store.text;

  const sideBarCollapse = store.sideBarCollapse;
 
  const toggleSidebar = () => {
    updateStoreFunc(null, null, null , (pre: storeType['store']) => {
      const {collapseWidth, expandWidth, homePageOffset} = config.sideBar;
      return {...pre, sideBarCollapse: !pre.sideBarCollapse, sideBarWidth: pre.sideBarCollapse ? (window.location.pathname !== "/home" ? expandWidth :  expandWidth - homePageOffset): collapseWidth}
    })
  };

  return (
    <div
      style={{
        width: store.sideBarWidth + "px",
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",
        padding: "10px",
      }}
    >
      {sideBarCollapse ? <img style={{ paddingLeft: "20px"}} src={logoOnly} height={"60px"}/> : <img style={{ paddingLeft: "20px"}} src={logo} width={"114px"} height={"60px"}/>}
      <NavItem icon={<HomeIcon css={css`path:first-of-type { stroke: ${store.currentPage === "/home" ? "#FFFFFF" : pageSelectedColor}}`} style={{width: "25px", height: "25px"}}/>} label={text.Home} link="/home" collapsed={sideBarCollapse} handleClick={handleNavigationClick} selected={store.currentPage === "/home"} color={pageSelectedColor} pageNameColor={pageNameColor} />
      <NavItem icon={<SongIcon css={css`path:first-of-type { stroke: ${store.currentPage === "/songRequests" ? "#FFFFFF" : pageSelectedColor}}`} style={{width: "25px", height: "25px"}}/>} label={text["Song Request"]} link="/songRequests" collapsed={sideBarCollapse} handleClick={handleNavigationClick} selected={store.currentPage === "/songRequests"} color={pageSelectedColor} pageNameColor={pageNameColor} />
      <NavItem icon={<CircleIcon css={css`path:first-of-type { stroke: ${store.currentPage === "/dataEntry" ? "#FFFFFF" : pageSelectedColor}}`} style={{width: "25px", height: "25px"}}/>} label={text["Data Entry"]} link="/dataEntry" collapsed={sideBarCollapse} handleClick={handleNavigationClick} selected={store.currentPage === "/dataEntry"} color={pageSelectedColor} pageNameColor={pageNameColor} />
      <NavItem icon={<BookmarkIcon css={css`path:first-of-type { stroke: ${store.currentPage === "/library" ? "#FFFFFF" : pageSelectedColor}}`} style={{width: "25px", height: "25px"}}/>} label={text.Library} link="/library" collapsed={sideBarCollapse} handleClick={handleNavigationClick} selected={store.currentPage === "/library"} color={pageSelectedColor} pageNameColor={pageNameColor} />
      <NavItem icon={<ProfileIcon css={css`path:first-of-type { stroke: ${store.currentPage === "/profile" ? "#FFFFFF" : pageSelectedColor}}`} style={{width: "25px", height: "25px"}}/>} label={text.Profile} link="/profile" collapsed={sideBarCollapse} handleClick={handleNavigationClick} selected={store.currentPage === "/profile"} color={pageSelectedColor} pageNameColor={pageNameColor} />
      <ButtonBase style={{paddingLeft: "20px", marginTop: "10px"}} onClick={toggleSidebar}>
        {!sideBarCollapse ? <ArrowLeft css={css`path:first-of-type { stroke: ${pageSelectedColor}}`}/> : <ArrowLeft css={css`path:first-of-type { stroke: #FFFFFF}`} style={{transform: 'scaleX(-1)'}}/>}
        {!sideBarCollapse && <span style={{ marginLeft: "10px", color: pageSelectedColor }}>{text['Menu Hide']}</span>}
      </ButtonBase>
    </div>
  )
}

type NavItemType = {
  icon: ReactElement<any, any>,
  label: string,
  link: string,
  collapsed: boolean,
  handleClick: (link: string) => void,
  selected: boolean,
  color: string,
  pageNameColor: string
}

const NavItem = ({ icon, label, link, collapsed, handleClick, selected, color, pageNameColor }: NavItemType) => {
  return (
    <ButtonBase
      style={{
        width: "100%",
        display: "flex",
        alignItems: "",
        justifyContent: "start",
        padding: "10px",
        paddingLeft: "20px",
        borderRadius: "8px",
        backgroundColor: "transparent",
        color: selected ? "#FFFFFF" : color,
      }}
      onClick={() => handleClick(link)}
    >
      {icon}
      {!collapsed && <span style={{ marginLeft: "10px" }}>{label}</span>}
    </ButtonBase>
  );
};
